// extracted by mini-css-extract-plugin
export default {"headerTop":"header_headerTop__Z5-Qx","title":"header_title__3nbMi"};